function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6V6.5C8 6.77614 8.22386 7 8.5 7C8.77614 7 9 6.77614 9 6.5V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V10H16V6Z",
  fill: "#8A99A8"
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 5.42737,
  y: 12.3527,
  width: 13,
  height: 10,
  rx: 3.5,
  transform: "rotate(-15 5.42737 12.3527)",
  stroke: "#8A99A8"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1903 14.1468C14.4047 14.947 13.9298 15.7695 13.1296 15.9839C12.3294 16.1983 11.5069 15.7234 11.2925 14.9232C11.0781 14.123 11.553 13.3005 12.3532 13.0861C13.1534 12.8717 13.9759 13.3466 14.1903 14.1468Z",
  stroke: "#8A99A8"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6464 16.1124L13.6123 15.8535L14.13 17.7854C14.2015 18.0521 14.0432 18.3263 13.7764 18.3978C13.5097 18.4692 13.2355 18.311 13.1641 18.0442L12.6464 16.1124Z",
  fill: "#8A99A8"
});
const SvgUnblocking = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnblocking, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unblocking.6292fca9.svg";
export { ForwardRef as ReactComponent };